import { post } from 'api/client';

type CreateParams = {
  name: string;
  postType: string;
  pageId: number;
  isGlobal: boolean;
};

export function createPagePostRequirement(params: CreateParams) {
  const data = new FormData();

  data.append('id', params.pageId.toString());
  data.append('text', params.name);
  data.append('post_type', params.postType);
  data.append('is_global', params.isGlobal ? '1' : '0');

  return post('/Pages/ajaxCreatePostRequirement', data);
}
